function FaqSectionModel({ id, sectionTitle, questions, }) {
  let obj = {};
  obj.id = id;
  obj.sectionTitle = sectionTitle;
  obj.questions = questions;
  return obj;
}

export default FaqSectionModel;